export default {
    common: {
        title: 'Editar Imagem',
        cancel: 'Cancelar',
        save: 'Salvar',
        crop: 'Cultura',
        adjustments: 'Ajustes',
        filters: 'Filtros',
        frames: 'Quadros',
        overlays: 'Sobreposições',
        text: 'Texto',
        stickers: 'Adesivos',
        brush: 'Escova',
        ai: 'Criar imagem usando IA',
        reset: 'Reiniciar',
        comingSoon: 'Em breve...',
        apply: 'Aplicar',
        undo: 'Desfazer',
        redo: 'Refazer',
        flipHorizontal: 'Inverter Horizontalmente',
        flipVertical: 'Inverter Verticalmente',
        rotateClockwise: 'Girar no sentido horário',
        rotateAntiClockwise: 'Girar no sentido anti-horário',
        warning: 'Aviso',
        discard: 'Descartar',
        continue: 'Continue editando',
        discardHeading: 'Descartar suas alterações?',
        discardSubHeading: 'Se você fechar o editor de imagens, suas alterações não serão salvas',
        subtitle: 'Os formatos de imagem suportados são PNG e JPEG',
        clone: 'Clonar',
        delete: 'Excluir',
    },
};
